import { render } from "./Reservatorio.vue?vue&type=template&id=3b21bd73"
import script from "./Reservatorio.vue?vue&type=script&lang=js"
export * from "./Reservatorio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__